/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Guides_AvailableInputs */

const en_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No KNP guides available.`)
};

const fr_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun guide KNP disponible.`)
};

const de_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine KNP-Führer verfügbar.`)
};

const it_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna guida KNP disponibile.`)
};

const ru_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путеводители по КНП отсутствуют.`)
};

const es_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay guías KNP disponibles.`)
};

const zh_cn2_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有克鲁格国家公园的导游。`)
};

const ja_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用できる KNP ガイドはありません。`)
};

const hi_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी के लिए कोई गाइड उपलब्ध नहीं है।`)
};

const pt_pt2_knp_lookup_no_guides_available = /** @type {(inputs: Knp_Lookup_No_Guides_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há guias disponíveis sobre o Parque Nacional Kruger.`)
};

/**
* | output |
* | --- |
* | "No KNP guides available." |
*
* @param {Knp_Lookup_No_Guides_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_guides_available = /** @type {((inputs?: Knp_Lookup_No_Guides_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Guides_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_no_guides_available(inputs)
	if (locale === "de") return de_knp_lookup_no_guides_available(inputs)
	if (locale === "it") return it_knp_lookup_no_guides_available(inputs)
	if (locale === "ru") return ru_knp_lookup_no_guides_available(inputs)
	if (locale === "es") return es_knp_lookup_no_guides_available(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_no_guides_available(inputs)
	if (locale === "ja") return ja_knp_lookup_no_guides_available(inputs)
	if (locale === "hi") return hi_knp_lookup_no_guides_available(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_no_guides_available(inputs)
	return en_knp_lookup_no_guides_available(inputs)
});